// ====================================================
// VidyaTrack - Forgot Password Page
// ====================================================

import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiMail, FiArrowLeft, FiCheckCircle } from "react-icons/fi";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "react-toastify";
import useSEO from "../../seo/useSEO";

export default function ForgotPassword() {
  useSEO({ title: "Reset Password", path: window.location.pathname, noindex: true });
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const { resetPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) { setError("Email is required"); return; }
    if (!/\S+@\S+\.\S+/.test(email)) { setError("Invalid email address"); return; }
    setError(""); setLoading(true);
    try {
      await resetPassword(email.trim());
      setSent(true);
      toast.success("Password reset link sent!");
    } catch (err) {
      toast.error(err.message);
    } finally { setLoading(false); }
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #eef2fb 0%, #dce8ff 50%, #f0f4fb 100%)",
      display: "flex", alignItems: "center", justifyContent: "center", padding: "24px"
    }}>
      <div style={{ width: "100%", maxWidth: "400px" }}>
        <div style={{ textAlign: "center", marginBottom: "28px" }}>
          <img src="/vtLight.png" alt="VidyaTrack" style={{ width:56, height:56, objectFit:"contain", margin:"0 auto 12px", display:"block" }} />
          <h2 style={{ fontSize: "1.5rem", fontWeight: 700 }}>Reset Password</h2>
        </div>

        <div style={{
          background: "#fff", borderRadius: "var(--r16)",
          boxShadow: "0 10px 32px rgba(0,0,0,.10)", padding: "32px", border: "1px solid var(--border)"
        }}>
          {sent ? (
            <div style={{ textAlign: "center" }}>
              <FiCheckCircle size={48} style={{ color: "var(--green-600)", marginBottom: 16 }} />
              <h3 style={{ marginBottom: 8 }}>Check Your Email</h3>
              <p style={{ color: "var(--gray-500)", fontSize: "0.9rem", marginBottom: 24 }}>
                We've sent a password reset link to <strong>{email}</strong>
              </p>
              <Link to="/login" className="btn btn-primary btn-full">Back to Login</Link>
            </div>
          ) : (
            <>
              <p style={{ color: "var(--gray-500)", fontSize: "0.88rem", marginBottom: 24 }}>
                Enter your registered email and we'll send you a link to reset your password.
              </p>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label">Email Address</label>
                  <div style={{ position: "relative" }}>
                    <FiMail style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "var(--gray-500)" }} />
                    <input
                      type="email"
                      className={`form-control${error ? " error" : ""}`}
                      placeholder="your@school.com"
                      value={email}
                      onChange={e => { setEmail(e.target.value); setError(""); }}
                      style={{ paddingLeft: 38 }}
                    />
                  </div>
                  {error && <div className="form-error">{error}</div>}
                </div>
                <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
                  {loading ? <><div className="spinner spinner-sm" /> Sending...</> : "Send Reset Link"}
                </button>
              </form>
            </>
          )}
        </div>

        <p style={{ textAlign: "center", marginTop: 20, fontSize: "0.85rem" }}>
          <Link to="/login" style={{ color: "var(--blue-700)", display: "flex", alignItems: "center", justifyContent: "center", gap: 4 }}>
            <FiArrowLeft size={14} /> Back to Login
          </Link>
        </p>
      </div>
    </div>
  );
}
